import axios from 'axios';

const NODE_BASE_URL = process.env.REACT_APP_ABT_ALL_APIS_BASE_URL;
const STATIONS_BASE_PATH = '/api/v1/web_portal/operations/stations';
const STOPS_BASE_PATH = '/api/v1/web_portal/operations/stops';

const getAuthHeaders = () => {
  const authData = localStorage.getItem('authData');
  if (!authData) return {};

  try {
    const parsed = JSON.parse(authData);
    const token = parsed?.userToken || {};

    return {
      'access-token': token['access-token'],
      uid: token.uid,
      client: token.client,
    };
  } catch {
    return {};
  }
};

export const updateStationCodeApi = (id: string, station_code: string) =>
  axios.patch(
    `${NODE_BASE_URL}${STATIONS_BASE_PATH}/${id}`,
    { station_code },
    { headers: getAuthHeaders() }
  );

export const uploadMultipleStationsApi = (file: File) => {
  const formData = new FormData();
  formData.append('stations_file', file);

  return axios.post(
    `${NODE_BASE_URL}${STATIONS_BASE_PATH}/upload-multiple-stations`,
    formData,
    {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

export const updateStopCodeApi = (id: string, stop_code: string) =>
  axios.patch(
    `${NODE_BASE_URL}${STOPS_BASE_PATH}/${id}`,
    { stop_code },
    { headers: getAuthHeaders() }
  );

export const uploadMultipleStopsApi = (file: File) => {
  const formData = new FormData();
  formData.append('stops_file', file);

  return axios.post(
    `${NODE_BASE_URL}${STOPS_BASE_PATH}/upload-multiple-stops`,
    formData,
    {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};
